/**
 * AppealSlice Letter Draft Reducers
 * 
 * Reducers for managing letter draft content.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { LetterDraftView } from '../../types/appealTypes';
import { AppealSliceState } from '../state';

// =============================================================================
// LETTER DRAFT REDUCERS
// =============================================================================

/**
 * Update the letter draft with partial data
 */
export const updateLetterDraft: CaseReducer<AppealSliceState, PayloadAction<Partial<LetterDraftView>>> = (
  state,
  action
) => {
  if (state.currentAppeal) {
    state.currentAppeal.letterDraft = {
      ...state.currentAppeal.letterDraft,
      ...action.payload,
    };
    state.hasUnsavedChanges = true;
  }
};
